import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faBars } from "@fortawesome/free-solid-svg-icons";
import { Offcanvas, Button } from "react-bootstrap";
import logo from "../../assets/images/logo.PNG";
import navigations from "../../navigation/vertical/index";
import "./index.css";

const SideNavBar = () => {
    const location = useLocation();

    const [expandedMenus, setExpandedMenus] = useState<{ [key: string]: boolean; }>({});
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isSidebarVisible, setSidebarVisibility] = useState(window.innerWidth >= 875);

    useEffect(() => {
        const handleResize = () => {
            setSidebarVisibility(window.innerWidth >= 875);
        };

        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const toggleSubMenu = (id: string) => {
        setExpandedMenus((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };

    const isMenuActive = (navItem: any) => {
        if (location.pathname === navItem.navLink) {
            return true;
        }
        if (navItem.subMenu) {
            return navItem.subMenu.some(
                (subNavItem: any) => location.pathname === subNavItem.navLink
            );
        }
        return false;
    };

    const renderNavItem = (navItem: any) => {
        const isActive = isMenuActive(navItem);
        const backgroundColor = isActive ? "#F2F2F2" : "transparent";

        return (
            <div key={navItem.id} className="desktop-sidebar-links-content-one">
                <div
                    className="desktop-sidebar-whole-link-content"
                    style={{ backgroundColor: backgroundColor, }}>

                    <NavLink
                        to={navItem.navLink}
                        style={{
                            backgroundColor: "transparent",
                            borderRadius: "2px",
                            padding: "3% 2%",
                            borderLeft: isActive ? "3px solid #FF1001" : "4px",
                        }}
                        className="desktop-sidebar-link-content"
                        onClick={(e) => {
                            if (navItem.subMenu) {
                                e.preventDefault();
                                toggleSubMenu(navItem.id);
                            }
                        }}>
                        <FontAwesomeIcon
                            icon={navItem.icon}
                            className="desktop-sidebar-link-icon" />
                        <span>{navItem.title}</span>
                    </NavLink>
                    {navItem.subMenu && (
                        <FontAwesomeIcon
                            icon={faAngleDown}
                            style={{
                                transform: expandedMenus[navItem.id]
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                backgroundColor: backgroundColor,
                            }}
                            className="desktop-sidebar-link-content-expand-arrow"
                            onClick={() => toggleSubMenu(navItem.id)}
                        />
                    )}
                </div>
                {navItem.subMenu && expandedMenus[navItem.id] && (
                    <div className="desktop-sidebar-sub-link-content">
                        {navItem.subMenu.map((subNavItem: any) => {
                            const isSubActive = location.pathname.startsWith(
                                subNavItem.navLink
                            );
                            return (
                                <NavLink
                                    key={subNavItem.id}
                                    to={subNavItem.navLink}
                                    style={{
                                        backgroundColor: isSubActive ? "#F2F2F2" : "transparent",
                                        borderRadius: isSubActive ? "2px" : "0",
                                        padding: "3% 2%",
                                    }}
                                    className="desktop-sidebar-sub-link"
                                >
                                    <div className="desktop-sidebar-sub-link-text">
                                        <FontAwesomeIcon
                                            icon={subNavItem.icon}
                                            style={{
                                                border: isSubActive
                                                    ? "1px solid #FF1001"
                                                    : "1px solid #384262",
                                                backgroundColor: "transparent",
                                            }}
                                            className="desktop-sidebar-sub-link-icon"
                                        />
                                        <span className="desktop-sidebar-sub-link-text-title">{subNavItem.title}</span>
                                    </div>
                                </NavLink>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div>
            {isSidebarVisible && (
                <div className="desktop-sidebar-links-content-one">
                    {navigations.map(renderNavItem)}
                </div>
            )}
            {!isSidebarVisible && (
                <div className="toggle-btn" onClick={toggleSidebar}>
                    <Button variant="warning">
                        <FontAwesomeIcon icon={faBars} />
                    </Button>
                </div>
            )}
            <Offcanvas show={isSidebarOpen} onHide={toggleSidebar}>
                <Offcanvas.Header closeButton closeLabel="hi" closeVariant="warning">
                    <img src={logo} alt="Logo" className="off-canvas-header-logo" />
                </Offcanvas.Header>
                <Offcanvas.Body className="off-canvas-whole-body">
                    {navigations.map(renderNavItem)}
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    );
};

export default SideNavBar;
